export class NotificationModel {

 public id : number;
 public headText : string ;
 public text: string ;
 public link: string ;
 public type : number ;
 public beginDateForSend: string ;
 public endDateForSend: string ;
 public timeLive : number ;
 public btFileInfo1Id: string ;
 public btFileInfo1Name: string ;
 public newbtFileInfo1: any ;
 public btFileInfo2Id: string ;
 public btFileInfo2Name: string ;
 public newbtFileInfo2: any ;
 public isDeleted : boolean;
 public virtualPath1: string;
 public virtualPath2: string;
 public isStoped: boolean;
 public selectedDomains = new Array<number>();
 public time: string;
 public endTime: string;
 public ttl: number;
 public geo: number;
 public geoId: number;
 public defaultDomains: boolean;
 public email: string;
 public isActual: boolean;
 public domainCount: number;
 public isLocked: boolean;
 public sentCount : number ;
 public errorCount : number ;
 public nid : string;
 public isCurrentNotif: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/notification.model.ts